/*eslint-disable*/

import React from "react";

export interface Tab {
    value: string;
    label: string;
    content: React.ReactNode;
}

interface TabsComponentProps {
    tabs: Tab[];
    defaultTab?: string;
    renderTabsList?: (tabs: Tab[]) => React.ReactNode;
    renderTabTrigger?: (tab: Tab) => React.ReactNode;
    renderTabContent?: (tab: Tab) => React.ReactNode;
}

export function TabsComponent({
    tabs,
    defaultTab,
    renderTabsList,
    renderTabTrigger,
    renderTabContent,
}: TabsComponentProps) {
    const [activeTab, setActiveTab] = React.useState(
        defaultTab || tabs[0]?.value
    );

    const handleTabClick = (tabValue: string) => {
        console.log(`Tab clicked: ${tabValue}`); // Log the clicked tab value
        console.log(`Active tab before change: ${activeTab}`); // Log the previous active tab value
        setActiveTab(tabValue);
        console.log(`Active tab after change: ${tabValue}`); // Log the active tab after change
    };

    return (
        <div className="w-[400px]">
            {renderTabsList ? (
                renderTabsList(tabs)
            ) : (
                <div
                    className={`grid w-full text-left`}
                    style={{
                        gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))`,
                    }}
                >
                    {tabs.map((tab) =>
                        renderTabTrigger ? (
                            renderTabTrigger(tab)
                        ) : (
                            <button
                                key={tab.value}
                                className={`py-2 text-left text-xs sm:text-sm md:text-lg break-words max-w-[90%]
        ${activeTab === tab.value ? "font-bold border-b border-black" : "border-b"}
    `}
                                onClick={() => handleTabClick(tab.value)}
                            >
                                {tab.label}
                            </button>
                        )
                    )}
                </div>
            )}
            {tabs.map((tab) =>
                activeTab === tab.value ? (
                    <div key={tab.value}>
                        {renderTabContent ? renderTabContent(tab) : tab.content}
                    </div>
                ) : null
            )}
        </div>
    );
}
